import React from 'react';
import { Modal, Input, Form } from 'antd';

const { TextArea } = Input;

const PassReportModal = ({ visible, onClose, onConfirm }) => {
    const [form] = Form.useForm();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            onConfirm(values);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="Pass Report"
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Confirm"
            cancelText="Cancel"
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="auditRemark"
                    label="Note"
                    rules={[{ required: false, message: 'Please enter a note' }]}
                >
                    <TextArea rows={4} placeholder="Enter note..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PassReportModal;
